module.exports = __webpack_public_path__ + "img/menu.c7e5f29f.svg";